import { useUnreleasedHostingVersionsState } from '@features/devTools/hooks/useUnreleasedHostingVersionsState'
import { HostingVersionCatalogue, ReleaseFamily } from '@feedyou-ai/feedbot-schema'
import semver from 'semver'

export function useAvailableVersionsForFamily(
  catalogue: HostingVersionCatalogue,
  family: ReleaseFamily
) {
  const showUnreleased = useUnreleasedHostingVersionsState()?.displayUnreleasedHostingVersions

  const latestVersion = catalogue[family!]?.latestVersion

  return catalogue[family]?.versions?.filter(
    v =>
      family !== ReleaseFamily.Release || // I <3 PRETTIER
      showUnreleased ||
      semver.lte(v.version, latestVersion)
  )
}
